/**
 * Cantidad de borrados que se envían al mismo tiempo en la eliminación múltiple
 * de los mantenedores de personal y equipos.
 *
 * No existe un endpoint masivo, así que la eliminación múltiple llama al endpoint de
 * borrado individual una vez por registro. Hacerlo de forma secuencial obliga a esperar
 * una ida y vuelta al servidor por registro, así que se envían en tandas de este tamaño.
 *
 * El valor va alineado con el límite de conexiones simultáneas por host del navegador
 * (~6): subirlo más no acelera nada porque el navegador igual las encola, y solo agrega
 * presión sobre el pool de conexiones de la base de datos.
 */
export const DELETE_CONCURRENCY = 6;
